import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BootstrapHookService {
  constructor() {}

  /**
   * metodo chiamato all'inizio dell'esecuzione di BootstrapService.bootstrap
   */
  async beforeBootstrap(): Promise<void> {}

  /**
   * metodo chiamato alla fine dell'esecuzione di BootstrapService.bootstrap
   */
  async afterBootstrap(): Promise<void> {}
}
